/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import VueAnalytics from "vue-analytics";
import Router from "vue-router";
import Meta from "vue-meta";
import axios from "@/plugins/axios";
import store from "@/store";

import AuthService from "@/services/auth";
import UserService from "@/services/user";
import Cookies from 'js-cookie'

// Routes
import paths from "./paths";

const DEFAULT_TITLE = "Estratégias";

Vue.use(Router);


// Create a new router
const router = new Router({
    routes: paths,
    // mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (to.path != from.path) {
            return { x: 0, y: 0 };
        }
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return false
    },
});

Vue.use(Meta);

if (process.env.GOOGLE_ANALYTICS) {
    Vue.use(VueAnalytics, {
        id: process.env.GOOGLE_ANALYTICS,
        router,
        autoTracking: {
            page: process.env.NODE_ENV !== "development",
        },
    });
}

router.beforeEach(async(to, from, next) => {
    //
    if (store.getters.getIsEditingMode) {
        if (confirm("Deseja realmente sair sem salvar?")) {
            store.commit("setIsEditingMode", false);
            next();
        } else {
            return;
        }
    }

    let redirect = null;

    if (to.name != "NotFound" && to.name != "Error") {
        if (!store.getters.getLoggedUser) {
            redirect = await authenticateUser(to);
        }

        // await buildDynamicFilters()todo
    }

    if (to.name) {
        document.title = to.name + " - " + DEFAULT_TITLE;
    } else {
        document.title = DEFAULT_TITLE;
    }

    if (redirect) {
        next(redirect);
    } else {
        next();
    }
});

router.beforeResolve((to, from, next) => {
    if (to.meta.cacheUrl && !to.query.cached && !to.query.noCache) {
        // Se a rota está configurada para cache e
        // ainda não é um resultado cacheado resolve o cache
        let redirectTo = RouterCacheService.resolve(to, from);

        if (redirectTo) {
            next(redirectTo);
        } else {
            next();
        }
    } else {
        if (to.query.cached && to.meta.cacheResult) {
            to.meta.cacheResult = RouterCacheService.getResult(to);
        }
        next();
    }
});

async function authenticateUser(to) {
    let redirect = null;
    if (to.query.token) {
        AuthService.setToken(to.query.token);
    }

    // Se possuir token no localStorage define o header global com ele
    let token = AuthService.getToken();

    if (token) {
        axios.httpApi.defaults.headers.common[
            "Authentication-Token"
        ] = token;
        axios.httpApi.defaults.headers.common["Authentication-Token"] = token;
        axios.httpTask.defaults.headers.common["Authentication-Token"] = token;
        axios.httpHealthCheck.defaults.headers.common["Authentication-Token"] = token
    }

    // Salva o usuário logado no Estado centralizado do Vuex
    let user = await UserService.getUserMe()
        .then((res) =>{
            store.commit("setLoggedUser", res);
            const urlToContinue = Cookies.get('URL_CONTINUE')
            if (urlToContinue) {
                Cookies.remove('URL_CONTINUE')
                window.location.href = urlToContinue
            }
        })
        .catch((err) => {
            console.error(err);
            // store.commit('setErrorMessage', err)
            // redirect = '/error'
        });

    // console.log(user);

    // let query = Object.assign({}, to.query);
    if (to.query.token) {
        delete to.query.token;
    }

    return redirect;
}

export default router;